import { render } from "./Item1.vue?vue&type=template&id=399ad466&ts=true"
import script from "./Item1.vue?vue&type=script&lang=ts"
export * from "./Item1.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\map-web-4\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__